<template>
  <b-container class="row">
    <b-col>
      <dl class="row">
        <dt class="col-sm-6">Name</dt>
        <dd class="col-sm-6">{{ student.firstName }} {{ student.lastName }}</dd>
        <dt class="col-sm-6">Asurite</dt>
        <dd class="col-sm-6">{{ student.asuriteId }}</dd>
      </dl>
    </b-col>
    <b-col>
      <dl class="row">
        <dt class="col-sm-6">College</dt>
        <dd class="col-sm-6">{{ student.college }}</dd>
        <dt class="col-sm-6">Major</dt>
        <dd class="col-sm-6">{{ student.major }}</dd>
      </dl>
    </b-col>
  </b-container>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    student: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
</style>
